import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { WHY, STEPS } from "../../data/site";
import { Reveal, Kicker } from "./Reveal";

const Icon = ({ name, className }) => {
  const C = Icons[name] || Icons.Check;
  return <C className={className} />;
};

export const WhyChooseUs = () => (
  <section className="relative overflow-hidden bg-ffc-blue py-24 lg:py-32" data-testid="why-choose-us">
    <div className="pointer-events-none absolute -right-40 top-0 h-[500px] w-[500px] rounded-full bg-white/5 blur-3xl" />
    <div className="relative mx-auto max-w-[1400px] px-5 lg:px-10">
      <Reveal><span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.25em] text-white/70"><span className="h-px w-8 bg-ffc-red" />Why Choose Us</span></Reveal>
      <Reveal delay={0.05}>
        <h2 className="font-display mt-4 max-w-3xl text-4xl font-extrabold text-white sm:text-5xl lg:text-6xl">
          Built on trust. Finished with pride.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
        {WHY.map((w, i) => (
          <motion.div key={w.title}
            initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: (i % 4) * 0.08 }}
            data-testid={`why-${i}`}>
            <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-white/10 text-white ring-1 ring-white/15">
              <Icon name={w.icon} className="h-7 w-7" />
            </span>
            <h3 className="font-display mt-5 text-xl font-bold text-white">{w.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-white/70">{w.desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export const HowItWorks = () => (
  <section className="bg-ffc-light py-24 lg:py-32" data-testid="how-it-works">
    <div className="mx-auto max-w-[1400px] px-5 lg:px-10">
      <div className="text-center">
        <Reveal><Kicker>How It Works</Kicker></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display mx-auto mt-4 max-w-2xl text-4xl font-extrabold sm:text-5xl lg:text-6xl">
            Simple, transparent, done right.
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <motion.div key={s.n}
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay: i * 0.1 }}
            className="relative rounded-2xl bg-white p-8 shadow-[0_10px_40px_-24px_rgba(13,59,142,0.4)]"
            data-testid={`step-${i}`}>
            <span className="font-display text-5xl font-extrabold text-ffc-line">{s.n}</span>
            <h3 className="font-display mt-4 text-xl font-bold">{s.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-ffc-gray">{s.desc}</p>
            <span className="absolute right-7 top-8 h-2.5 w-2.5 rounded-full bg-ffc-red" />
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
